<template>
  <div class="flex w-full items-start gap-3">
    <div class="flex size-9 shrink-0 items-center justify-center">
      <AtomIcon
        :icon-name="iconName"
        icon-type="outline"
        icon-size="md"
        shape-variant="round"
        :color-variant="iconColorVariant"
      />
    </div>
    <div class="flex min-w-0 flex-1 flex-col items-start gap-1">
      <AtomText :text="title" font-size="text-sm" font-style="font-semibold" />
      <MoleculeTag
        class="block"
        v-for="(tag, index) in tags"
        :key="index"
        :value="tag.value"
        :type="tag.type"
        :variant="tag.variant ?? 'normal'"
        :icon-name="tag.iconName"
      />
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
export type NextStepTag = {
  value: string;
  type?: string;
  variant?: 'normal' | 'bullet' | 'icon';
  iconName?: string;
};

type Props = {
  iconName: string;
  iconColorVariant?: string;
  title: string;
  tags?: NextStepTag[];
};

withDefaults(defineProps<Props>(), {
  tags: () => [],
});
</script>

<style scoped></style>
